/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { AttachmentsAttachment } from '../models/attachments-attachment';
import { Envelope } from '../models/envelope';
import {JobView} from '@models/JobView';
@Injectable({
  providedIn: 'root',
})
class AttachmentService extends __BaseService {
  static readonly AttachmentListPath = '/api/attachment/list';
  static readonly AttachmentDownloadPath = '/api/attachment/download';
  static readonly AttachmentUploadPath = '/api/attachment/upload';
  static readonly AttachmentGetAllPath = '/api/attachment';
  static readonly AttachmentUpdatePath = '/api/attachment';
  static readonly AttachmentCreatePath = '/api/attachment';
  static readonly AttachmentGetPath = '/api/attachment/{id}';
  static readonly AttachmentDeletePath = '/api/attachment/{id}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `AttachmentService.AttachmentListParams` containing the following parameters:
   *
   * - `jobId`:
   *
   * - `showInvisible`:
   *
   * @return OK
   */
  AttachmentListResponse(params: AttachmentService.AttachmentListParams): __Observable<__StrictHttpResponse<Envelope<AttachmentsAttachment[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.jobId != null) __params = __params.set('jobId', params.jobId.toString());
    if (params.showInvisible != null) __params = __params.set('showInvisible', params.showInvisible.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/attachment/list`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AttachmentsAttachment[]>>;
      })
    );
  }
  /**
   * @param params The `AttachmentService.AttachmentListParams` containing the following parameters:
   *
   * - `jobId`:
   *
   * - `showInvisible`:
   *
   * @return OK
   */
  AttachmentList(params: AttachmentService.AttachmentListParams): __Observable<Envelope< AttachmentsAttachment[] >> {
    return this.AttachmentListResponse(params).pipe(
      __map(_r => _r.body as Envelope<AttachmentsAttachment[]>)
    );
  }

  /**
   * @param location undefined
   * @return OK
   */
  AttachmentDownloadResponse(location: string): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (location != null) __params = __params.set('location', location.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/attachment/download`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param location undefined
   * @return OK
   */
  AttachmentDownload(location: string): __Observable<{}> {
    return this.AttachmentDownloadResponse(location).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @param params The `AttachmentService.AttachmentUploadParams` containing the following parameters:
   *
   * - `jobId`:
   *
   * - `fileDescription`:
   *
   * - `attachmentType`:
   *
   * @return OK
   */
  AttachmentUploadResponse(params: AttachmentService.AttachmentUploadParams): __Observable<__StrictHttpResponse<{}>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.jobId != null) __params = __params.set('jobId', params.jobId.toString());
    if (params.jobEngineerId != null) __params = __params.set('jobEngineerId', params.jobEngineerId.toString());
    if (params.fileDescription != null) __params = __params.set('fileDescription', params.fileDescription.toString());
    if (params.attachmentType != null) __params = __params.set('attachmentType', params.attachmentType.toString());
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/attachment/upload`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<{}>;
      })
    );
  }
  /**
   * @param params The `AttachmentService.AttachmentUploadParams` containing the following parameters:
   *
   * - `jobId`:
   *
   * - `jobEngineerId`:
   *
   * - `fileDescription`:
   *
   * - `attachmentType`:
   *
   * @return OK
   */
  AttachmentUpload(params: AttachmentService.AttachmentUploadParams): __Observable<{}> {
    return this.AttachmentUploadResponse(params).pipe(
      __map(_r => _r.body as {})
    );
  }

  /**
   * @return OK
   */
  AttachmentGetAllResponse(): __Observable<__StrictHttpResponse<Envelope<AttachmentsAttachment[]>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/attachment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AttachmentsAttachment[]>>;
      })
    );
  }
  /**
   * @return OK
   */
  AttachmentGetAll(): __Observable<Envelope<AttachmentsAttachment[]>> {
    return this.AttachmentGetAllResponse().pipe(
      __map(_r => _r.body as Envelope<AttachmentsAttachment[]>)
    );
  }

  /**
   * @param entity undefined
   * @return OK
   */
  AttachmentUpdateResponse(entity: AttachmentsAttachment): __Observable<__StrictHttpResponse<Envelope<AttachmentsAttachment>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = entity;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/attachment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AttachmentsAttachment>>;
      })
    );
  }
  /**
   * @param entity undefined
   * @return OK
   */
  AttachmentUpdate(entity: AttachmentsAttachment): __Observable<Envelope<AttachmentsAttachment>> {
    return this.AttachmentUpdateResponse(entity).pipe(
      __map(_r => _r.body as Envelope<AttachmentsAttachment>)
    );
  }

  /**
   * @param attachment undefined
   * @return OK
   */
  AttachmentCreateResponse(attachment: AttachmentsAttachment): __Observable<__StrictHttpResponse<Envelope<AttachmentsAttachment>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = attachment;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/attachment`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AttachmentsAttachment>>;
      })
    );
  }
  /**
   * @param attachment undefined
   * @return OK
   */
  AttachmentCreate(attachment: AttachmentsAttachment): __Observable<Envelope<AttachmentsAttachment>> {
    return this.AttachmentCreateResponse(attachment).pipe(
      __map(_r => _r.body as Envelope<AttachmentsAttachment>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  AttachmentGetResponse(id: number): __Observable<__StrictHttpResponse<Envelope<AttachmentsAttachment>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/attachment/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<AttachmentsAttachment>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  AttachmentGet(id: number): __Observable<Envelope<AttachmentsAttachment>> {
    return this.AttachmentGetResponse(id).pipe(
      __map(_r => _r.body as Envelope<AttachmentsAttachment>)
    );
  }

  /**
   * @param id undefined
   * @return OK
   */
  AttachmentDeleteResponse(id: number): __Observable<__StrictHttpResponse<Envelope<any>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/attachment/${encodeURIComponent(id)}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Envelope<any>>;
      })
    );
  }
  /**
   * @param id undefined
   * @return OK
   */
  AttachmentDelete(id: number): __Observable<Envelope<any>> {
    return this.AttachmentDeleteResponse(id).pipe(
      __map(_r => _r.body as Envelope<any>)
    );
  }
}

module AttachmentService {

  /**
   * Parameters for AttachmentList
   */
  export interface AttachmentListParams {
    jobId: number;
    showInvisible?: boolean;
  }

  /**
   * Parameters for AttachmentUpload
   */
  export interface AttachmentUploadParams {
    jobId: number;
    jobEngineerId: number;
    fileDescription: string;
    attachmentType: 0 | 1 | 2 | 3 | 4;
  }
}

export { AttachmentService }
